// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import UniProjectPage from './pages/UniProjectPage';
import PersonalProjectsPage from './pages/PersonalProjectsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage'; // Import LegalPage
import PrivacyPage from './pages/PrivacyPage'; // Import PrivacyPage
import { LanguageProvider } from './translations/LanguageContext';
import GenerativeDesignXAI from './uni/GenerativeDesignXAI';
import ProjectModuleWeb from './uni/ProjectModuleWeb'; 
import MobileApplications from './uni/MobileApplications'; // Import MobileApplications
import PersonalHealthXAI from './uni/PersonalHealthXAI'; // Add import for PersonalHealthAI
import Circa from './personal/Circa';
import PaperSoccer from './personal/PaperSoccer';
import Dot2D from './personal/Dot2D'; // Add import for Dot2D component
import ScrollToTop from './components/ScrollToTop'; 

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            {/* Main */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/legal" element={<LegalPage />} /> {/* New Route */}
            <Route path="/privacy" element={<PrivacyPage />} /> {/* New Route */}

            {/* Uni Projects */}
            <Route path="/uni-projects" element={<UniProjectPage />} />
            <Route
              path="/uni-projects/generative-design-x-ai"
              element={<GenerativeDesignXAI />}
            />
            <Route
              path="/uni-projects/project-module-web"
              element={<ProjectModuleWeb />}
            />
            <Route
              path="/uni-projects/mobile-applications"
              element={<MobileApplications />}
            />
            <Route
              path="/uni-projects/personal-health-x-ai"
              element={<PersonalHealthXAI />}
            />

            {/* Personal Projects */}
            <Route path="/personal-projects" element={<PersonalProjectsPage />} />
            <Route path="/personal-projects/circa" element={<Circa />} />
            <Route path="/personal-projects/paper-soccer" element={<PaperSoccer />} /> {/* Add new route */}
            <Route path="/personal-projects/dot2d" element={<Dot2D />} /> {/* Add new route for Dot2D */}
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
